import { KnownDeliveryDtoDeliveryType } from '@groundfloor-platform/mgmt-service-g-sdk';

export const deliveryTypeToInternalOrExternalMap: Record<KnownDeliveryDtoDeliveryType, 'internal' | 'external'> = {
  [KnownDeliveryDtoDeliveryType.InboundDryCleaning]: 'external',
  [KnownDeliveryDtoDeliveryType.OutboundDryCleaning]: 'internal',
  [KnownDeliveryDtoDeliveryType.InboundMail]: 'external',
  [KnownDeliveryDtoDeliveryType.OutboundMail]: 'internal',
  [KnownDeliveryDtoDeliveryType.InboundParcel]: 'external',
  [KnownDeliveryDtoDeliveryType.PeerToPeer]: 'internal',
  [KnownDeliveryDtoDeliveryType.RetailOrder]: 'external',
  [KnownDeliveryDtoDeliveryType.LockerpointOrder]: 'external'
};
